import { Text } from "@/ui/core";
import { VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

const MessagesInformationFooter = ({ testID }: ViewWithTestID) => {
  return (
    <VStack gap={12} paddingBottom={36} paddingTop={24}>
      <Text
        color={ColorToken.NeutralSecondary}
        testID={joinTestIDs(testID, "footer", "1")}
        variant="caption"
      >
        Your Equip team will not always be able to respond immediately. You
        should receive a response within 1-3 business days.
      </Text>
      <Text
        color={ColorToken.NeutralSecondary}
        testID={joinTestIDs(testID, "footer", "2")}
        variant="caption"
      >
        Equip does not handle medical emergencies. Call 911 immediately if you
        believe you are experiencing a medical emergency. Do not rely on
        communication through this website for urgent medical needs.
      </Text>
    </VStack>
  );
};

export default MessagesInformationFooter;
